var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPointMap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_28852_15473)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 53.5,
    rx: 7,
    ry: 2.5,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_28852_15473)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 4C37.598 4 47 13.402 47 25C47 33.8926 41.4727 41.4942 33.6663 44.5567L27.1961 53.4007C27.0612 53.5858 26.8821 53.7369 26.6739 53.8412C26.4657 53.9455 26.2346 54 26 54C25.7654 54 25.5343 53.9455 25.3261 53.8412C25.1179 53.7369 24.9388 53.5858 24.8039 53.4007L18.3337 44.5567C10.5273 41.4941 5 33.8926 5 25C5 13.402 14.402 4 26 4Z",
    fill: "#079D56"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1144 15.8587C35.1144 15.5806 34.9595 15.3518 34.6987 15.2452C34.4405 15.1386 34.1668 15.1932 33.968 15.3908L25.3597 23.9542L28.4813 27.0583C28.6388 27.2142 28.724 27.4222 28.724 27.6432V30.0557C28.724 30.6017 28.2773 31.0462 27.7273 31.0462H21.6235V32.1381C21.6235 32.5046 21.9231 32.8036 22.2923 32.8036H34.4482C34.8175 32.8036 35.117 32.5046 35.117 32.1381V15.8587H35.1144ZM21.6261 27.6666L21.6235 30.1649H27.7248C27.7867 30.1649 27.8358 30.1155 27.8358 30.0531V27.664L24.7322 24.5781L21.6261 27.6666ZM20.7379 30.1675L20.7405 27.6458C20.7405 27.4248 20.8257 27.2194 20.9832 27.0635L24.1074 23.9568L18.1792 18.0581C18.032 17.9099 17.8461 17.8345 17.6525 17.8345C17.5544 17.8345 17.4537 17.8553 17.353 17.8943C17.0586 18.0139 16.8856 18.2765 16.8856 18.591V29.4136C16.8856 29.8295 17.2264 30.1675 17.6421 30.1675H20.7379ZM35.0395 14.4341C35.6308 14.6759 36 15.2244 36 15.8613V32.1407C36 32.9934 35.3029 33.6875 34.4457 33.6875H22.2897C21.4325 33.6875 20.7353 32.9934 20.7353 32.1407V31.0488H17.6421C16.7384 31.0462 16 30.3131 16 29.4136V18.591C16 17.9177 16.3899 17.338 17.0147 17.0806C17.6396 16.8232 18.3264 16.9584 18.804 17.4342L24.7322 23.3329L33.3457 14.7695C33.7976 14.3197 34.4482 14.1897 35.0395 14.4341Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_28852_15473",
    x: 17,
    y: 49,
    width: 18,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_28852_15473"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_28852_15473",
    x: 0,
    y: 0,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28852_15473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28852_15473",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPointMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pointMap.cf2062bc7d1e384f4be6cba6e9a66268.svg";